/* The mark, drawn live instead of the PNG: the PNG's faces are all paler than
   #C0E1ED and vanish on light grounds. This SVG takes its fills from theme
   tokens, so the mark holds in both modes with no plate behind it.
   Same grid as the logo: mint(0,0,0) · ice(1,0,0) · peri(1,0,1) · dash(1,-1,0). */

const EX = [0.866, -0.5];
const EY = [-0.866, -0.5];
const EZ = [0, -1];

type P2 = [number, number];

function pt(o: P2, a: number, b: number, c: number): P2 {
  return [
    o[0] + a * EX[0] + b * EY[0] + c * EZ[0],
    o[1] + a * EX[1] + b * EY[1] + c * EZ[1],
  ];
}

function pts(list: P2[]): string {
  return list.map((p) => `${p[0].toFixed(2)},${p[1].toFixed(2)}`).join(' ');
}

const A = 10;

function faces(o: P2) {
  const B = pt(o, A, 0, 0);
  const C = pt(o, 0, A, 0);
  const T = pt(o, 0, 0, A);
  const TR = pt(o, A, 0, A);
  const TL = pt(o, 0, A, A);
  const TB = pt(o, A, A, A);
  return {
    left: pts([o, C, TL, T]),
    right: pts([o, B, TR, T]),
    top: pts([T, TR, TB, TL]),
    outline: pts([o, B, TR, TB, TL, C]),
  };
}

const MiniCube = ({ o, tone }: { o: P2; tone: string }) => {
  const f = faces(o);
  return (
    <g>
      <polygon points={f.left} className={`mk-${tone} mk-l`} />
      <polygon points={f.right} className={`mk-${tone} mk-r`} />
      <polygon points={f.top} className={`mk-${tone} mk-t`} />
    </g>
  );
};

const MiniDashed = ({ o }: { o: P2 }) => {
  const f = faces(o);
  return (
    <polygon
      points={f.outline}
      fill="none"
      className="mk-dash crawl"
      strokeWidth="1.4"
      strokeDasharray="2.6 2"
      strokeLinejoin="round"
    />
  );
};

/* mint front-left, ice behind-right, peri on top of ice, dashed front-right */
const BASE: P2 = [9, 34];
const ICE: P2 = [BASE[0] + A * 0.866, BASE[1] - A * 0.5];
const PERI: P2 = [ICE[0], ICE[1] - A];
const DASH: P2 = [ICE[0] + A * 0.866, ICE[1] + A * 0.5];

const BrandMark = ({ size = 30 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    aria-hidden="true"
    focusable="false"
    className="brandmark"
  >
    <MiniCube o={ICE} tone="ice" />
    <MiniCube o={PERI} tone="peri" />
    <MiniCube o={BASE} tone="mint" />
    <MiniDashed o={DASH} />
  </svg>
);

export default BrandMark;
